module.exports = __webpack_public_path__ + "img/125.f5add80d.jpg";